'use strict';

const { default: Swiper, A11y, Autoplay, Navigation, Pagination } = require("swiper");
Swiper.use([Navigation, Pagination, Autoplay, A11y]);

function initEinsteinCarousel($carousel) {
    if (!$carousel.hasClass('swiper-initialized')) {
        var configs = {
            slidesPerView: $carousel.data('option-slidesperview') || 5,
            slidesPerGroup: $carousel.data('option-slidespergroupdesktop') || 5,
            centeredSlides: $carousel.data('option-centeredslides') || false,
            loop: $carousel.data('option-loop') || false,
            threshold: 5,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            watchOverflow: $carousel.data('option-watchoverflow') || true,
            breakpoints: {
                320: {
                    slidesPerView: $carousel.data('option-slidesperviewmobile') || 1.5,
                    slidesPerGroup: $carousel.data('option-slidespergroup') || 1,
                },
                1024: {
                    slidesPerView: $carousel.data('option-slidesperview') || 5,
                    slidesPerGroup: $carousel.data('option-slidespergroupdesktop') || 5,
                    centeredSlides: $carousel.data('option-centeredslidesdesktop') || false,
                },
            },
            lazy: true
        };


        if ($carousel.data('option-rebranded')) {
            var spaceBetween = $carousel.data('option-spacebetween') || 10;
            var lgSlidesPerView = $carousel.data('option-slidesperviewlg') || $carousel.data('option-slidesperview') || 5;
            var lgSlidesPerGroup = $carousel.data('option-slidespergrouplg') || $carousel.data('option-slidespergroupdesktop') || 5;
            var slidesOffsetMobile = $carousel.data('option-slidesoffsetmobile') || 0;
            var slidesOffsetDesktop = $carousel.data('option-slidesoffsetdesktop') || slidesOffsetMobile;

            configs.spaceBetween = spaceBetween;
            configs.slidesOffsetBefore = slidesOffsetMobile;
            configs.slidesOffsetAfter = slidesOffsetMobile;
            configs.pagination = {
                el: $carousel.find('.swiper-pagination')[0],
                clickable: true,
            };
            var smSlidesPerView = $carousel.data('option-slidesperviewsm') || configs.breakpoints[1024].slidesPerView;
            var smSlidesPerGroup = $carousel.data('option-slidespergroupsm') || configs.breakpoints[1024].slidesPerGroup;
            var desktopSlidesPerView = configs.breakpoints[1024].slidesPerView;
            var desktopSlidesPerGroup = configs.breakpoints[1024].slidesPerGroup;
            var desktopCenteredSlides = configs.breakpoints[1024].centeredSlides;

            configs.breakpoints[320].spaceBetween = spaceBetween;
            configs.breakpoints[1024].slidesPerView = smSlidesPerView;
            configs.breakpoints[1024].slidesPerGroup = smSlidesPerGroup;
            configs.breakpoints[1024].spaceBetween = spaceBetween;
            configs.breakpoints[1024].slidesOffsetBefore = slidesOffsetDesktop;
            configs.breakpoints[1024].slidesOffsetAfter = slidesOffsetDesktop;
            configs.breakpoints[1200] = {
                slidesPerView: desktopSlidesPerView,
                slidesPerGroup: desktopSlidesPerGroup,
                centeredSlides: desktopCenteredSlides,
                spaceBetween: spaceBetween,
                slidesOffsetBefore: slidesOffsetDesktop,
                slidesOffsetAfter: slidesOffsetDesktop,
            };
            configs.breakpoints[1440] = {
                slidesPerView: lgSlidesPerView,
                slidesPerGroup: lgSlidesPerGroup,
                centeredSlides: $carousel.data('option-centeredslidesdesktop') || false,
                spaceBetween: spaceBetween,
                slidesOffsetBefore: slidesOffsetDesktop,
                slidesOffsetAfter: slidesOffsetDesktop,
            };
        }

        new Swiper($carousel[0], configs);
    }
}

function alignToEditorialCarouselV2($swiperCo, $swiperEl) {
    if ($swiperCo.closest('.editorial-carousel-v2').length) {
        $swiperEl.data({
            'option-slidesperviewmobile': 1.5,
            'option-slidesperviewsm': 2,
            'option-slidespergroupsm': 2,
            'option-slidesperview': 3,
            'option-slidespergroupdesktop': 3,
            'option-slidesperviewlg': 4,
            'option-slidespergrouplg': 4,
        });
    }
}

function bindLoaderButtons($container) {
    $container[0].addEventListener('click', function (e) {
        var btn = e.target.closest('[data-loader-btn]');
        if (btn) {
            btn.classList.add('active-loader');
        }
    }, true);
}

function observeCarousels() {

    $('.einstein-products-carousel').each(function () {
        var $swiperCo = $(this);
        bindLoaderButtons($swiperCo);
        var $swiperEl = $swiperCo.find('.swiper.is-einstein-carousel:not(.swiper-initialized)');

        if ($swiperEl.length > 0) {
            var $swiperWr = $swiperEl.find('.swiper-wrapper.js-swiper-wrapper');
            if ($swiperWr.find('.product').length > 0) {
                alignToEditorialCarouselV2($swiperCo, $swiperEl);
                initEinsteinCarousel($swiperEl);
            } else {
                var observer = new MutationObserver(function (mutations, obs) {
                    if ($swiperWr.find('.product').length > 0) {
                        alignToEditorialCarouselV2($swiperCo, $swiperEl);
                        initEinsteinCarousel($swiperEl);
                        obs.disconnect();
                    }
                });
                observer.observe($swiperCo[0], { childList: true, subtree: true });
            }
        } else {
            var observer = new MutationObserver(function (mutations, obs) {
                var $swiperEl = $swiperCo.find('.swiper.is-einstein-carousel:not(.swiper-initialized)');
                var $swiperWr = $swiperEl.find('.swiper-wrapper.js-swiper-wrapper');
                if ($swiperWr.find('.product').length > 0) {
                    alignToEditorialCarouselV2($swiperCo, $swiperEl);
                    initEinsteinCarousel($swiperEl);
                    obs.disconnect();
                }
            });
            observer.observe($swiperCo[0], { childList: true, subtree: true });
        }
    });
}

module.exports = $(function () {
    observeCarousels();
});
